var map = {
	"./comfirBtnGaen.png": "SA7T",
	"./comfirBtnGakhm.png": "KGbv",
	"./comfirBtnGathai.png": "bXZk",
	"./comfirBtnGavi.png": "aoIE",
	"./comfirBtnGazh-tw.png": "Vrwc"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "lx9U";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hongbao/img ^\.\/comfirBtnGa.*\.png$
// module id = lx9U
// module chunks = 1